import { type PropsWithChildren } from 'react';

import { HistogramAnnotationsTrackProps } from '../../components/annotations-histogram/types.js';

/** HistogramChart Annotations.Track subcomponent props */
export const Track = (
  props: PropsWithChildren<HistogramAnnotationsTrackProps>,
) => null;

Track['displayName'] = 'HistogramAnnotations.Track';
